export default [
  {
    text: 'category.table.name',
    value: 'name',
  },
];
